<template>
  <div class="card">
    <div :class="[{'card-content-width': boolWidth}]">
      <div class="card__image">
        <responsive-image :picture="image" />
      </div>
      <div class="card__date subline">
        {{ date }}
      </div>
      <h3 class="card__title">
        {{ title }}
      </h3>
      <slot />
      <div class="card__tag subline">
        <div
          v-for="tag in tags"
          :key="tag.id"
          class="card__tag--border"
        >
          {{ tag.TagName.toUpperCase() }}
        </div>
      </div>
      <span
        v-if="url"
      >
        <NavigationChevronRight class="card__arrowRight" />
      </span>
    </div>
  </div>
</template>

<script>
import NavigationChevronRight from '~/assets/icons/navigation_chevron_right.svg?component'
import ResponsiveImage from './responsive-image.vue'

export default {
  components: {
    NavigationChevronRight,
    ResponsiveImage
  },
  name: 'Card',
  props: {
    image: {
      type: Object,
      default() {
        return {}
      }
    },
    date: {
      type: String,
      default() {
        return ''
      }
    },
    title: {
      type: String,
      default() {
        return ''
      }
    },
    tags: {
      type: Array,
      default() {
        return []
      }
    },
    url: {
      type: String,
      default() {
        return ''
      }
    },
    boolWidth: {
      type: Boolean,
      default() {
        return false
      }
    }
  }
}
</script>
